var _rect, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLikeIconinline = function SvgLikeIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    x: 5.5,
    y: 5.5,
    stroke: "#2B4BEE",
    strokeWidth: 3,
    rx: 30.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2B4BEE",
    d: "M3.5 3.5h65v65h-65z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2B4BEE",
    strokeWidth: 2,
    d: "M1 1h9v9H1zM62 1h9v9h-9zM1 62h9v9H1zM62 62h9v9h-9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#like-icon_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.25 31.5h-4.375a.875.875 0 0 0-.875.875V47.25c0 .483.392.875.875.875h4.375a.875.875 0 0 0 .875-.875V32.375a.875.875 0 0 0-.875-.875M49.522 32.317a3.46 3.46 0 0 0-2.914-1.692H39.5V26.25a5.26 5.26 0 0 0-4.052-5.111 1.73 1.73 0 0 0-2.073 1.72v5.693l-3.5 4.086v15.487h14.88a3.95 3.95 0 0 0 3.925-3.391l1.313-10.5v-.008a3.05 3.05 0 0 0-.47-1.91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "like-icon_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 21h28v28H22z"
  })))));
};
export default SvgLikeIconinline;